import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { EnumService } from 'src/app/utility/services/enum-service/enum.service';
import { FileHandlerService } from 'src/app/utility/services/file-handler/file-handler.service';
import { MessageService } from 'src/app/utility/services/message/message.service';
import { HrDashboardService } from '../../service/hr-dashboard/hr-dashboard.service';

@Component({
  selector: 'app-hr-dashboard-claims-report',
  templateUrl: './hr-dashboard-claims-report.component.html',
  styleUrls: ['./hr-dashboard-claims-report.component.scss']
})
export class HrDashboardClaimsReportComponent implements OnInit {

  reportTypes: any[] = [];
  groupPolicies: any = [];
  GroupPolicyAnniversaries: any = [];

  inputForm = this.fb.group({
    reportType: [null, Validators.required],
    groupPolicyId: [null, Validators.required],
    groupPolicyAnniversaryId: [null, Validators.required],
  });

  constructor(
    private fb: FormBuilder,
    private hrDashboardService: HrDashboardService,
    private messageService: MessageService,
    private fileHandlerService: FileHandlerService,
    private enumService: EnumService
  ) { }

  ngOnInit() {
    this.getReportTypes();
    this.getAllGroupPolicyByHr();
  }

  getReportTypes() {
    this.enumService.getHrDashboardClaimsReportType().subscribe(res => {
      this.reportTypes = res;
    });
  }

  getAllGroupPolicyByHr() {
    this.hrDashboardService.getGroupPolicyByHrUser().subscribe(res => {
      this.groupPolicies = res;
    });
  }

  onchangeGroupPolicy(groupPolicyId) {
    this.inputForm.controls['groupPolicyAnniversaryId'].setValue(null);

    this.hrDashboardService.getLastTwoAnniversariesByGroupPolicy(groupPolicyId).subscribe(res => {
      this.GroupPolicyAnniversaries = res;
    });
  }

  downloadReport() {
    const obj = this.inputForm.value;

    this.hrDashboardService.generateReport(obj).subscribe((response: any) => {
      this.downloadParseExcel(response);
      this.messageService.show(response.message, response.status ? 'success' : 'error');
    }, error => {
      this.messageService.show(error.error.message, 'error');
    });
  }

  downloadParseExcel(response): void {
    if (response.file) {
      const binary = atob(response.file);
      const array = new Uint8Array(binary.length);
      for (let i = 0; i < binary.length; i++) { array[i] = binary.charCodeAt(i); }
      this.fileHandlerService.downloadExcel(array, response.filename + ".xlsx");
    } else {
      this.messageService.show(response.message, 'error');
    }
  }

}
